/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { isKeyExist } from "@/lib/object-mutation";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { DocumentListingError } from "./document-listing-error";
import { typeCheck } from "@/lib/type-check";
import { AuditListingV2 } from "./audit-listing-v2";
import { AuditTableV2 } from "./audit-table-v2";
import { AuditTable } from "./audit-table";
import { AuditListing } from "./audit-listing";
import { AuditCollapsible } from "./audit-collapsible";
import { AuditTableV4 } from "./audit-table-v4";

export const AuditLogViewer = ({ documentData }: any) => {
  const isTypeTwo = isKeyExist(documentData, "regions");

  function isValidObject(value: any) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
  }
  return (
    <div className="flex gap-5 flex-col">
      <ConditionRenderer condition={isTypeTwo}>
        {isValidObject(documentData)
          ? Object.entries(documentData).map(([key, obj]: any, index) => {
              return (
                <React.Fragment key={index}>
                  <div className="border text-sm bg-white px-3 py-2 rounded-[11px]">
                    {key}
                  </div>

                  <div className="flex flex-col gap-5 pl-6">
                    {Object.entries(obj).map(
                      ([ObjKey, value]: any, objIndex) => {
                        return (
                          <AuditCollapsible label={ObjKey} key={objIndex}>
                            <ConditionRenderer
                              condition={value?.items ? false : true}
                            >
                              <ErrorBoundary
                                fallbackRender={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <DocumentListingError
                                    error={error}
                                    errorInfo={error.stack || ""}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                              >
                                {Array.isArray(value) ? (
                                  <AuditTableV4
                                    data={value}
                                    keyValue={key}
                                    parentKey={`detailsData.domain_json.${key}.${ObjKey}`}
                                  />
                                ) : (
                                  <AuditListingV2
                                    data={value}
                                    keyValue={key}
                                    parentKey={`detailsData.domain_json.${key}.${ObjKey}`}
                                  />
                                )}
                              </ErrorBoundary>
                            </ConditionRenderer>
                            <ConditionRenderer
                              condition={value?.items ? true : false}
                            >
                              <ErrorBoundary
                                fallbackRender={({
                                  error,
                                  resetErrorBoundary,
                                }) => (
                                  <DocumentListingError
                                    error={error}
                                    errorInfo={error.stack || ""}
                                    resetErrorBoundary={resetErrorBoundary}
                                  />
                                )}
                              >
                                <AuditTableV2
                                  data={value.items}
                                  keyValue={key}
                                  parentKey={`detailsData.domain_json.${key}.${ObjKey}.items`}
                                />
                              </ErrorBoundary>
                            </ConditionRenderer>
                          </AuditCollapsible>
                        );
                      }
                    )}
                  </div>
                </React.Fragment>
              );
            })
          : null}
      </ConditionRenderer>

      <ConditionRenderer condition={!isTypeTwo}>
        {isValidObject(documentData)
          ? Object.entries(documentData).map(([key, obj]: any, index) => {
              return (
                <AuditCollapsible label={key} key={index} isParent={true}>
                  <div className="flex flex-col  gap-5 pl-6">
                    {Object.entries(obj).map(([ObjKey, value], objIndex) => {
                      return (
                        <AuditCollapsible label={ObjKey} key={objIndex}>
                          <ConditionRenderer
                            condition={typeCheck(value) === "Object"}
                          >
                            <ErrorBoundary
                              fallbackRender={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <DocumentListingError
                                  error={error}
                                  errorInfo={error.stack || ""}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                            >
                              <AuditListing
                                data={value}
                                keyValue={key}
                                parentKey={`detailsData.domain_json.${key}.${ObjKey}`}
                              />
                            </ErrorBoundary>
                          </ConditionRenderer>
                          <ConditionRenderer
                            condition={typeCheck(value) === "Array"}
                          >
                            <ErrorBoundary
                              fallbackRender={({
                                error,
                                resetErrorBoundary,
                              }) => (
                                <DocumentListingError
                                  error={error}
                                  errorInfo={error.stack || ""}
                                  resetErrorBoundary={resetErrorBoundary}
                                />
                              )}
                            >
                              <AuditTable
                                data={value}
                                keyValue={key}
                                parentKey={`detailsData.domain_json.${key}.${ObjKey}`}
                              />
                            </ErrorBoundary>
                          </ConditionRenderer>
                        </AuditCollapsible>
                      );
                    })}
                  </div>
                </AuditCollapsible>
              );
            })
          : null}
      </ConditionRenderer>
    </div>
  );
};
